import { instance } from '../../../services/api';

export default (runFileId: number) => instance.get(`/api/runsheet/${runFileId}`);